'use client'

import useSWR from 'swr'
import getCategoryNavigationAction from '../actions/get-category-navigation-action'
import { getCacheKeyFromDocument } from './graphql-fetcher'
import { GET_CATEGORY_NAVIGATION } from '../graphql/product/category-navigation.graphql'
import type { GetCategoryNavigationQuery } from '../graphql/product/generated/graphql-types'

export default function useCategoryNavigation(isActive: boolean) {
  const { data, error, isValidating } = useSWR<GetCategoryNavigationQuery>(
    isActive ? getCacheKeyFromDocument(GET_CATEGORY_NAVIGATION) : null,
    () => getCategoryNavigationAction()
  )
  return {
    data,
    error,
    isValidating,
  }
}
